import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const usePluggableEntityTableElements = (_entity, entityType) => {
  const pluginTableElements = usePluginEntities("components.shared.entityTableElements");
  const tableElements = pluginTableElements.filter((action) => action.useCondition ? !!action.useCondition() : true);
  const pluggableColumnRenderers = tableElements.reduce(
    (acc, curr) => ({ ...acc, ...curr.getColumnRenderer(entityType) }),
    {}
  );
  const pluggableAttributes = tableElements.reduce((acc, curr) => [...acc, ...curr.attributes], []);
  const pluggableAttributeNames = tableElements.reduce((acc, curr) => [...acc, curr.attributeName], []);
  const pluggableExpandedSections = tableElements.reduce(
    (acc, curr) => ({ ...acc, ...curr.expandedSection(entityType) }),
    {}
  );
  const getPluggableTableCells = (entityId) => tableElements.reduce(
    (acc, curr) => [
      ...acc,
      {
        component: curr.tableCellComponent
      }
    ],
    []
  ).map(({ component: PluggableTableCell }) => /* @__PURE__ */ React.createElement(PluggableTableCell, { key: entityId, entityId, entityType }));
  const pluggableTableHeaders = tableElements.reduce((acc, curr) => [...acc, ...curr.attributes], []).map((attribute) => /* @__PURE__ */ React.createElement("th", { key: attribute.id, className: `entity-table-header-${attribute.id}` }, attribute.title));
  return {
    pluggableColumnRenderers,
    pluggableAttributes: {
      attributeNames: pluggableAttributeNames,
      attributes: pluggableAttributes
    },
    pluggableExpandedSections,
    getPluggableTableCells,
    pluggableTableHeaders
  };
};
export default usePluggableEntityTableElements;
